import {onFind} from "@elements/init-modules-in-scope";
import {removeClass, addClass, findIn, closest, on,trigger} from '@elements/dom-utils';

export function init () {
    onFind('.js-trigger-submit', function (element) {

        on('change', (e) => {
            let form = closest('form', element);
            if (form) {
                form.dispatchEvent(new Event('submit', {bubbles: true, cancelable: true}))
            }
        }, element);

    });
}
